import { render, staticRenderFns } from "./workmenu.vue?vue&type=template&id=4805f9cb"
import script from "./workmenu.vue?vue&type=script&lang=js"
export * from "./workmenu.vue?vue&type=script&lang=js"
import style0 from "./workmenu.vue?vue&type=style&index=0&id=4805f9cb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./workmenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports